import React from 'react';
// react bootstrap
import Spinner from 'react-bootstrap/Spinner';

const LoadingScreen = () => {
  return (
    <div className={'text-center'}>
      <h2 style={{ color: 'var(--brandSecondary)' }}>
        Flamingo Reading Tracker
      </h2>
      <Spinner animation='grow' variant='danger' className='mt-5' />
    </div>
  );
};

export default LoadingScreen;
